import { Item, Section } from './index.styled';
import { Container } from 'components/container';
import data from './data.json';
import { GradiantText } from 'components/text';
import { classNames } from 'primereact/utils';
import { LineDivider } from 'components/LineDivider';

const ItemTemplate = ({ icon, label, text }) => {
  return (
    <Item>
      <span className={classNames('icon', icon)} />
      <div className="details">
        <h6>{label}</h6>
        <p>{text}</p>
      </div>
    </Item>
  );
};

const Services = () => {
  return (
    <Section>
      <LineDivider top />
      <Container fluid>
        <div className="grid">
          <div className="col-12 md:col-8 md:col-offset-2 sec-head">
            <h6>WHAT'S BEST ABOUT US?</h6>
            <GradiantText>
              We are the Online digital
              <br /> product development agency!
            </GradiantText>
          </div>
        </div>
        <div className="grid m-0">
          {data.map((item, i) => (
            <div key={i} className="col-12 md:col-4">
              <ItemTemplate {...item} />
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Services;
